// src/utils/reloadOnChunkError.js
export function setupReloadOnChunkError() {
  window.addEventListener('error', (event) => {
    const message = event?.message || '';
    const source = event?.filename || '';

    // Detecta errores por chunks rotos (MIME o 404)
    const isChunkError =
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module') ||
      (source &&
        source.includes('/assets/') &&
        message.includes('Unexpected token'));

    if (isChunkError) {
      console.warn('🔁 Detected broken chunk, reloading page...');
      window.location.reload(true);
    }
  });
}
